import { keys } from 'lodash';

const getKeys = (someEnum: { [key: string]: string | number }) => keys(someEnum).filter(x => !(parseInt(x) >= 0))

export const enumsUtils = {
    getKeys,
}
